const showIngredient =
  process.env.REACT_APP_SHOW_INGREDIENT?.toUpperCase() === "TRUE";

export const TEXT_VN = {
  pages: {
    about: "Triết lý",
    ...(showIngredient && { ingredient: "Nguyên liệu" }),
    space: "Không gian",
    menu: "Thực đơn",
    contact: "Đặt bàn",
    blog: "Nấu và Ăn",
  },
  home: "Trang chủ",
  contactUs: "Kết nối với chúng tôi:",
  language: "Ngôn ngữ:",
};

export const TEXT_EN = {
  pages: {
    about: "About",
    ...(showIngredient && { ingredient: "Ingredient" }),
    space: "Space",
    menu: "Menu",
    contact: "Contact",
    blog: "Blog",
  },
  home: "Home",
  contactUs: "Contact us:",
  language: "Language:",
};
